import { Dialog, DialogContent, DialogProps, DialogTitle } from '@mui/material';
import { LoadingState } from 'components/ui';
import { FLAGGED_FEATURE } from '../../../common/constants/features';
import FeatureFlagMenuItem from '../feature-flag-menu-item/FeatureFlagMenuItem';
import useCheckFeatures from '../hooks';

const FeatureFlagMenu = ({ open, onClose }: DialogProps) => {
  const [, , areFeaturesReady] = useCheckFeatures();

  // Preferences hydrate asynchronously; wait so persisted flags never appear disabled or accept stale clicks.
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle>Feature Flags</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, minHeight: '495px' }}>
        {areFeaturesReady ? (
          FLAGGED_FEATURE.map(feature => <FeatureFlagMenuItem key={feature.key} feature={feature} />)
        ) : (
          <LoadingState
            aria-label="Loading feature flags"
            label="Loading feature flags..."
            minHeight={0}
            role="status"
            size={18}
            sx={{ flexGrow: 1 }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FeatureFlagMenu;
